import { render } from "./ItemCarrinho.vue?vue&type=template&id=720c5957&scoped=true"
import script from "./ItemCarrinho.vue?vue&type=script&lang=js"
export * from "./ItemCarrinho.vue?vue&type=script&lang=js"

import "./ItemCarrinho.vue?vue&type=style&index=0&id=720c5957&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720c5957"]])

export default __exports__